module.exports = __webpack_public_path__ + "img/hero-collage.8bfcaa81.png";